import * as _ from 'lodash'

class Permissions {
    permissions = []
    constructor(permissions) {
        this.permissions = _.isArray(permissions) ? permissions : [];
    }
    add(name): void {
        this.permissions.push(name)
    }
    remove(name): void {
        if (this.has(name)) {
            const index = this.permissions.findIndex((x) => x == name)
            const findItems = this.permissions.slice(0, index).concat(this.permissions.slice(index + 1, this.permissions.length))
            this.permissions = findItems
        }
    }
    has(name): boolean {
        return this.permissions.includes(name)
    }
    getPermissions(): Array<string> {
        return this.permissions
    }
}


export default Permissions;
export { Permissions };